import React, { ReactNode } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles, styled } from "@material-ui/styles";
import themeConfig from "../config";

import checkedCheckedIcon from '../../assets/images/icons/checkbox-checked.svg';
import checkedIcon from '../../assets/images/icons/checkbox.svg';
import disabledIcon from '../../assets/images/icons/checkbox_disabled.svg';

const useStyle = makeStyles({
  root: {
    color: themeConfig.grayLight,
  },
  label: {
    fontFamily: themeConfig.fontFamilyRegular,
    fontSize: themeConfig.fontSize14,
    color: themeConfig.black,
  },
  checked: {
    color: themeConfig.black,
  },
});

interface IProps {
  id?: string;
  onChange?: Function;
  disabled?: boolean;
  checked?: boolean;
  name: string;
  maxLength?: number;
  value?: string;
  className?: string;
  children: ReactNode;
}

const UnCheckedIcon = styled('span')(({ theme }) => ({
  width: 20,
  height: 20,
  backgroundImage: `url("${checkedIcon}")`
}));

const CheckedIcon = styled(UnCheckedIcon)({
  backgroundImage: `url("${checkedCheckedIcon}")`,
});

const DisabledIcon = styled(UnCheckedIcon)({
  backgroundImage: `url("${disabledIcon}")`,
});

const AppCheckbox: React.FC<IProps> = ({
  id = "app-checkbox",
  className = "",
  children,
  onChange,
  value = "",
  disabled = false,
  checked = false,
  name,
}) => {
  const classes = useStyle();
  const handleChange = (e) => {
    onChange && onChange(e, { value, label: children });
  };

  return (
    <span className="app-checkbox">
      <FormControlLabel
        classes={{
          label: classes.label,
        }}
        control={
          <Checkbox
            id={id}
            className={className}
            checked={checked}
            onChange={handleChange}
            name={name}
            color="default"
            value={value}
            disabled={disabled}
            icon={<UnCheckedIcon />}
            checkedIcon={disabled ? <DisabledIcon /> : <CheckedIcon />}
            classes={{
              root: classes.root,
              checked: classes.checked,
            }}
          />
        }
        label={children}
      />
    </span>
  );
};

export default AppCheckbox;
